export default __webpack_public_path__ + "static/media/nft6.7ece5787.png";